export default "__VITE_ASSET__8fa4ac49__"